export default {
  userAddress: state => state.userAddress,
  tabselect: state => state.tabselect,
  onActive: state => state.onActive,
  busActive: state => state.busActive,
  ordersn: state => state.ordersn,
  myOrders: state => state.myOrders,
  searchnum: state => state.searchnum,
  reason: state => state.reason,
  backtime: state => state.backtime,
  descri: state => state.descri,
  refundid: state => state.refundid,
  backprice: state => state.backprice,
  oldaddress: state => state.oldaddress,
  isConfirm: state => state.isConfirm,
  isNull: state => state.isNull,
  defaultAddressIsNull: state => state.defaultAddressIsNull,
  isScroll: state => state.isScroll,
  addtype: state => state.addtype,
  cart: state => state.cart,
  shop: state => state.shop,
  price: state => state.price,
  thing: state => state.thing,
  companys: state => state.companys
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js